import $ from 'jquery';

var selectors = {
  parent: '.collapsible',
  trigger: '.collapsible__trigger',
  content: '.collapsible__content',
  activeModifier: 'collapsible--open'
};

export default function Collapsible(element) {
  this.$parent = $(element);
  this.$trigger = this.$parent.find(selectors.trigger);
  this.$content = this.$parent.find(selectors.content);

  this.bindEvents();
}

Collapsible.prototype.bindEvents = function() {
  this.$trigger.on('click', $.proxy(this.onTriggerClick, this));
};

Collapsible.prototype.onTriggerClick = function() {
  if (this.$parent.hasClass(selectors.activeModifier)) {
    this.hideContent();
  } else {
    this.showContent();
  }
};

Collapsible.prototype.showContent = function() {
  this.$parent.addClass(selectors.activeModifier);
};

Collapsible.prototype.hideContent = function() {
  this.$parent.removeClass(selectors.activeModifier);
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/collapsible/collapsible.js
 **/